import { BookingStateEnum, CalendarType } from '../../enums'
import { TenantSettings } from '../../models'

export const DEFAULT_TENANT_SETTINGS: TenantSettings = {
  showTimeInDashboard: false,
  notifyOnNewBookingDashboard: true,
  refreshDuration: 300,
  notifyOnNewBooking: true,
  thresholdBooking: 0,
  thresholdAutoAccept: 0,
  thresholdOutdated: 0,
  thresholdCancelation: 0,
  cancelationNote: '',
  termsForReservation: '',
  highlightOutdated: true,
  markMultipleUsedTables: true,
  onlineBookingPersonAmount: 20,
  useLengthOfStay: false,
  defaultLengthOfStay: '',
  lengthOfStay: [],
  useAutoAccept: false,
  anyroom: true,
  calendarType: CalendarType.MONTH,
  calendarDisplayPreference: 'employee',
  showAddressInCalendar: false,

  includeCancelLinkInCalendarAttachment: false,

  defaultStateBookings: BookingStateEnum.OPEN,
  requireEmail: false,
  requirePhone: false,
  reminderMail: true,

  visibleDashboardColumns: undefined,
  visibleCustomerColumns: undefined,
}
